import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import * as alertFunctions from '@shared';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

export enum AlertTypeValues { "success", "error", "info", "warning", "question" }

@Injectable()
export class AlertServices {
    @Output() onFormValidationErrorMessage: EventEmitter<any> = new EventEmitter();

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
    ) {


        //GENERIC FORM GROUP ERROR MESSAGE
        this.onFormValidationErrorMessage.subscribe((_errors) => {
            if (_errors) {
                let title = `<strong><u>${this.translate.instant('app.trn-invalid-form')}</u></strong>`;
                let htmlmessage = '';
                _errors.forEach(error => {
                    htmlmessage = htmlmessage + `
                    <div class="row">
                      <div class="col-5">
                        <b> ${this.translate.instant('app.trn-' + error.control.toLowerCase())}</b>
                      </div>
                      <div class="col-7">
                      ${this.translate.instant('app.trn-' + error.error.toLowerCase())}
                      </div>
                    </div>`
                });
                this.ShowHTMLMessage(title, htmlmessage);
            }
        });
    }

    // ShowMessage( AlertType:AlertTypeValues, _title , _message, cb = null) {
    //     this.translate.get(_title).subscribe((Title: string) => {
    //         this.translate.get(_message).subscribe((Message: string) => {
    //             alertFunctions.CSP_Message(_type, Title, Message, cb);
    //         });
    //     });
    // }


    ShowMessage(_type: "success" | "error" | "info" | "warning" | "question", _title, _message, cb = null) {
        this.translate.get(_title).subscribe((Title: string) => {
            this.translate.get(_message).subscribe((Message: string) => {
                alertFunctions.CSP_Message(_type, Title, Message, cb);
            });
        });
    }


    ShowConfirmMessage(_type: "success" | "error" | "info" | "warning" | "question", _title, _message) {
        return Observable.create((_operator) => {

            let Title = null
            let Message = null
            let ConfirmButtonText = null
            let CancelButtonText = null

            this.translate.get(_title).subscribe((res: string) => {
                Title = res
                this.translate.get(_message).subscribe((res: string) => {
                    Message = res
                    this.translate.get('app.trn-confirm-button-text').subscribe((res: string) => {
                        ConfirmButtonText = res
                        this.translate.get('app.trn-cancel-button-text').subscribe((res: string) => {
                            CancelButtonText = res

                            alertFunctions.CSP_Confirm_Message(_type, Title, Message, ConfirmButtonText, CancelButtonText).then((selected) => {
                                _operator.next(selected);
                            }, (_error) => {
                                _operator.error(_error);
                            })

                        });//CancelButtonText
                    }); //ConfirmButtonText 
                }); //Messge
            }); //Title


        }) //Observable
    }


    ShowInputMessage(_title, _message) {
        return Observable.create((_operator) => {

            let Title = null
            let Message = null
            let ConfirmButtonText = null
            let CancelButtonText = null

            this.translate.get(_title).subscribe((res: string) => {
                Title = res
                this.translate.get(_message).subscribe((res: string) => {
                    Message = res
                    this.translate.get('app.trn-confirm-button-text').subscribe((res: string) => {
                        ConfirmButtonText = res
                        this.translate.get('app.trn-cancel-button-text').subscribe((res: string) => {
                            CancelButtonText = res

                            alertFunctions.CSP_Input_Message(Title, Message, ConfirmButtonText, CancelButtonText).then((selected: any) => {
                                _operator.next(selected);
                            }, (_error) => {
                                _operator.error(_error);
                            })

                        });//CancelButtonText
                    }); //ConfirmButtonText 
                }); //Messge
            }); //Title


        }) //Observable
    }


    //TODO Build Options Dynamically i.e Position , Sticky timeout etc...

    ShowToastMessage(_type: "success" | "error" | "info" | "warning", _title, _message, _WithProgressBar?, _timeout = 1500) {

        let Title = null
        let Message = null
        this.translate.get(_title).subscribe((res: string) => {
            Title = res
            this.translate.get(_message).subscribe((res: string) => {
                Message = res

                switch (_type) {
                    case 'success': return this.toastr.success(Message, Title, { "progressBar": _WithProgressBar });
                    case 'error': return this.toastr.error(Message, Title, { "progressBar": _WithProgressBar });
                    case 'info': return this.toastr.info(Message, Title, { "progressBar": _WithProgressBar });
                    case 'warning': return this.toastr.warning(Message, Title, { "progressBar": _WithProgressBar });
                }

            });
        });

    }

    ShowToastMessageOnTOP(_type: "success" | "error" | "info" | "warning", _title, _message, _WithProgressBar?, _timeout = 1500) {

        let Title = null
        let Message = null
        this.translate.get(_title).subscribe((res: string) => {
            Title = res
            this.translate.get(_message).subscribe((res: string) => {
                Message = res
                
                switch (_type) {
                    case 'success': return this.toastr.success(Message, Title, { "progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-full-width' });
                    case 'error': return this.toastr.error(Message, Title, { "progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-full-width' });
                    case 'info': return this.toastr.info(Message, Title, { "progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-full-width' });
                    case 'warning': return this.toastr.warning(Message, Title, { "progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-full-width' });
                }

            });
        });

    }

    ShowHTMLMessage(_htmltitle, _htmlmessage) {
        alertFunctions.CSP_HTML_Message(_htmltitle, _htmlmessage);
    }

    ShowToastMessageDefault(_type: "success" | "error" | "info" | "warning", _title, _message, _WithProgressBar?, _timeout = 1500) {
        switch (_type) {
            case 'success': return this.toastr.success(_message, _title, { enableHtml: true ,"progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-left' });
            case 'error': return this.toastr.error(_message, _title, { enableHtml: true ,"progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-left' });
            case 'info': return this.toastr.info(_message, _title, { enableHtml: true, "progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-left' });
            case 'warning': return this.toastr.warning(_message, _title, { enableHtml: true ,"progressBar": _WithProgressBar, "timeOut": _timeout, "positionClass": 'toast-top-left' });
        }
    }


};



